import { render, staticRenderFns } from "./WrapperScreen.vue?vue&type=template&id=f4a07880"
import script from "./WrapperScreen.vue?vue&type=script&lang=js"
export * from "./WrapperScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports